import type { OrderStatusHistory } from "../models/OrderStatusHistory";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";
export function OrderStatusHistoryService() {
  return CreateCrudService<OrderStatusHistory, KeyValue>({
    Route: "orderstatushistory",
    EntityName: "OrderStatusHistory",
    PartialFields: ["Code", "OrderCode"],
    LoadingMessage: "Loading order history...",
    SavingMessage: "Saving order history...",
  });
}
